import { setSidebarOpenTab } from '@/atoms/persistedPreferencesAtoms';
import { useMobilePanel } from '@/components/layout/Navigation/mobile';
import { NavItem } from '@/components/layout/Navigation/sidebar/nav-item';
import { useDocumentInboxGate } from '@/features/flags';
import { Inbox } from 'lucide-react';
import { useCallback, useTransition } from 'react';
import { useIntl } from 'react-intl';

export const InboxNavItem = () => {
  const intl = useIntl();
  const [, startTransition] = useTransition();
  const { dismissMobileSidebar } = useMobilePanel();
  const gate = useDocumentInboxGate();

  const onClick = useCallback(() => {
    startTransition(() => {
      setSidebarOpenTab(undefined);
    });
    dismissMobileSidebar();
  }, [dismissMobileSidebar, startTransition]);

  if (gate !== 'on') {
    return null;
  }

  return (
    <NavItem
      label={intl.formatMessage({
        defaultMessage: 'Inbox',
        id: 'VCMKbtL+3b',
      })}
      icon={<Inbox />}
      href="/inbox"
      onClick={onClick}
      testId="sidebar-link-inbox"
    />
  );
};
